var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 0.399994C4.6983 0.399994 0.399902 4.69839 0.399902 9.99999C0.399902 14.4984 3.4975 18.2624 7.6735 19.304C7.6287 19.1744 7.5999 19.024 7.5999 18.8376V17.1968C7.2103 17.1968 6.5575 17.1968 6.3935 17.1968C5.7367 17.1968 5.1527 16.9144 4.8695 16.3896C4.5551 15.8064 4.5007 14.9144 3.7215 14.3688C3.4903 14.1872 3.6663 13.98 3.9327 14.008C4.4247 14.1472 4.8327 14.4848 5.2167 14.9856C5.5991 15.4872 5.7791 15.6008 6.4935 15.6008C6.8399 15.6008 7.3583 15.5808 7.8463 15.504C8.1087 14.8376 8.5623 14.224 9.1167 13.9344C5.9199 13.6056 4.3943 12.0152 4.3943 9.85599C4.3943 8.92639 4.7903 8.02719 5.4631 7.26959C5.2423 6.51759 4.9647 4.98399 5.5479 4.39999C6.9863 4.39999 7.8559 5.33279 8.0647 5.58479C8.7815 5.33919 9.5687 5.19999 10.3959 5.19999C11.2247 5.19999 12.0151 5.33919 12.7335 5.58639C12.9399 5.33599 13.8103 4.39999 15.2519 4.39999C15.8375 4.98479 15.5567 6.52479 15.3335 7.27519C16.0023 8.03119 16.3959 8.92799 16.3959 9.85599C16.3959 12.0136 14.8727 13.6032 11.6807 13.9336C12.5591 14.392 13.1999 15.68 13.1999 16.6504V18.8376C13.1999 18.9208 13.1815 18.9808 13.1719 19.052C16.9127 17.7408 19.5999 14.1888 19.5999 9.99999C19.5999 4.69839 15.3015 0.399994 9.9999 0.399994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.17a6475a79be5a7ed9cdbfa6fff0798c.svg";
export { ForwardRef as ReactComponent };